import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Notification",
    children: [
      {
        icon: "view-list",
        title: "List Notification",
        to: {
          name: "notification.list",
          query: {
            limit: 10,
            filter: "all",
            sort: "created_date",
            order: "desc",
          },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Notification",
        to: { name: "notification.create" },
        loggedIn: true,
      },
      {
        icon: "view-list",
        title: "Notification Inbox",
        to: {
          name: "notification.inbox",
          query: {
            limit: 10,
            filter: "all",
            sort: "created_date",
            order: "desc",
          },
        },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
];
